import React, { useCallback } from 'react'
import clsx from 'clsx'
import { ArrowIcon } from '../icons'
import { useCollapse } from './collapse-context'

import * as styles from './collapse.module.scss'

type Color = 'light' | 'primary' | 'secondary'

type Props = Omit<React.ComponentProps<'button'>, 'color'> & {
  color?: Color | null
}

export const CollapseButton = ({
  className,
  children,
  color,
  ...props
}: Props) => {
  const [open, setOpen] = useCollapse()

  const onClick = useCallback(() => setOpen(!open), [open])

  return (
    <button
      className={clsx(styles.button, className, color && styles[color])}
      {...props}
      onClick={onClick}
    >
      <span>{children}</span>
      <span>
        <ArrowIcon />
      </span>
    </button>
  )
}
